import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { describeArc } from '../../helpers';
import s from './LoadingSpinner.css';

const propTypes = {
    className: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
};

export class LoadingSpinner extends React.Component {
    static defaultProps = {
        className: undefined,
        color: '#F1CD44',
        size: 64,
    };

    constructor(props) {
        super(props);

        this.svgNode = null;
        this.exists = true;

        this.state = {
            visible: false,
        };
    }

    componentDidMount() {
        // Show spinner
        setTimeout(() => {
            if (this.exists) {
                this.setState({
                    visible: true,
                });
            }
        }, 128);
    }

    componentWillUnmount() {
        this.exists = false;
    }

    render() {
        const sizeHalf = this.props.size / 2;
        const strokeWidth = this.props.size / 10;
        const arcRadius = sizeHalf - strokeWidth;
        const arcDescription = describeArc(sizeHalf, sizeHalf, arcRadius, -45, 45);

        return (
            <svg
                ref={this.referenceSvgNode}
                className={classNames(
                    s.spinner,
                    {
                        [s.visible]: this.state.visible,
                    },
                    this.props.className
                )}
                width={this.props.size}
                height={this.props.size}
            >
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke={this.props.color}
                    strokeWidth={strokeWidth}
                    d={arcDescription}
                />

                <circle
                    cx={sizeHalf}
                    cy={sizeHalf}
                    r={arcRadius}
                    fill="none"
                    stroke={this.props.color}
                    strokeWidth={strokeWidth}
                    opacity={0.2}
                />
            </svg>
        );
    }

    referenceSvgNode = ref => (this.svgNode = ref);
}

LoadingSpinner.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/loaders/LoadingSpinner.jsx